export default "__VITE_ASSET__D2I6oBJQ__"